export default {
  title: 'Modalità occupato',
  form: {
    has_busy_mode: {
      label: 'Modalità occupato',
    },
    busy_mode_minutes: {
      label: 'Quanto tempo aggiungere al tuo tempo di preparazione normale?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 ora',
      },
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate con successo',
  },
};
